
import { Component, Vue } from "vue-property-decorator";

interface VekaletForm {
  davaTipi: string | null;
  davaDegeri: number | null;
  maktuKategori: string | null;
}

interface VekaletResponse {
  vekalet_ucreti: number;
  aciklama: string;
}

@Component
export default class VekaletUcretiHesaplayici extends Vue {
  form: VekaletForm = {
    davaTipi: null,
    davaDegeri: null,
    maktuKategori: null,
  };
  sonuc: VekaletResponse | null = null;
  yukleniyor: boolean = false;
  genelHataMesaji: string | null = null;

  davaTipleri = [
    { deger: "nispi", metin: "Nispi" },
    { deger: "maktu", metin: "Maktu" },
  ];

  maktuKategoriler = [
    { deger: "icra_takibi", metin: "İcra Takibi" },
    { deger: "ceza_davasi", metin: "Ceza Davası" },
    { deger: "idari_dava", metin: "İdari Dava" },
    { deger: "diger", metin: "Diğer" },
  ];

  get formGecerli(): boolean {
    if (!this.form.davaTipi) return false;

    if (this.form.davaTipi === "nispi") {
      return this.form.davaDegeri !== null && this.form.davaDegeri >= 0;
    }

    if (this.form.davaTipi === "maktu") {
      return !!this.form.maktuKategori;
    }

    return false;
  }

  // TL format
  tlFormat(sayi: number | null | undefined): string {
    if (sayi === null || sayi === undefined) return "";
    return sayi.toLocaleString("tr-TR", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  }

  handleApiError(error: any) {
    if (error && error.response && error.response.data) {
      const data = error.response.data;
      if (data.errors) {
        const messages = Object.values(data.errors).flat();
        if (messages.length > 0) {
          this.genelHataMesaji = messages.join('\n');
          return;
        }
      }
      if (typeof data === "string") {
        this.genelHataMesaji = data;
      } else if (data.message) {
        this.genelHataMesaji = data.message;
      } else {
        this.genelHataMesaji = "Beklenmeyen bir hata oluştu.";
      }
    } else {
      this.genelHataMesaji = "Sunucuya ulaşılamadı.";
    }
  }

  async hesapla() {
    if (!this.formGecerli) return;
    this.yukleniyor = true;
    this.sonuc = null;
    this.genelHataMesaji = null;

    try {
      const response = await (this as any).$http.post(
          "/api/v1/hesaplayicilar/vekalet-ucreti",
          {
            dava_tipi: this.form.davaTipi,
            dava_degeri: this.form.davaDegeri,
            kategori: this.form.maktuKategori,
          }
      );

      const data = response.data || response;
      this.sonuc = data;

    } catch (e) {
      this.handleApiError(e);
    } finally {
      this.yukleniyor = false;
    }
  }
}
